
import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DLRootCertificate } from './root-certificate';
import { Apollo } from 'apollo-angular';
import { map as _map } from 'lodash';

const RootCertificatesQuery = require('./gql/root-certificates.query.gql');
const RootCertificateQuery = require('./gql/root-certificate.query.gql');

const createDLRootCertificateMutation = require('./gql/create-root-certificate.mutation.gql');
const updateDLRootCertificateMutation = require('./gql/update-root-certificate.mutation.gql');
const deleteDLRootCertificateMutation = require('./gql/delete-root-certificate.mutation.gql');

export interface DLRootCertificatesQueryResult {
  rootCertificates: DLRootCertificate[]
  rootCertificatesCount: number
}

export type DLRootCertificateOrderBy = 'NAME' | 'CREATED_AT';
export type DLRootCertificateOrderByDirection = 'ASC' | 'DESC';

export class DLRootCertificateFilter {
  offset: number
  limit: number

  search = '';
  orderBy: DLRootCertificateOrderBy = 'NAME';
  orderDir: DLRootCertificateOrderByDirection = 'ASC';
}


@Injectable()
export class DLRootCertificateService {

  constructor(private apollo: Apollo) { }

  rootCertificates(filter: DLRootCertificateFilter): Observable<DLRootCertificatesQueryResult> {
    return this.apollo
      .query({
        query: RootCertificatesQuery,
        variables: {
          filter
        },
        fetchPolicy: 'no-cache'
      }).pipe(
      map((result) => {
        let items = result.data['dlRootCertificates']['items'];
        let total = result.data['dlRootCertificates']['total'];

        items = _map(items, item => new DLRootCertificate(item));

        return {
          rootCertificates: items,
          rootCertificatesCount: total,
        };
      }));
  }

  rootCertificate(id: string): Observable<DLRootCertificate> {
    return this.apollo
      .query({
        query: RootCertificateQuery,
        variables: {
          id
        },
        fetchPolicy: 'no-cache'
      }).pipe(
      map(result => result.data['dlRootCertificate'] ? new DLRootCertificate(result.data['dlRootCertificate']) : null));
  }

  create(rootCertificate: DLRootCertificate): Observable<DLRootCertificate> {
    return this.apollo
      .mutate({
        mutation: createDLRootCertificateMutation,
        variables: {
          input: rootCertificate.toCreateDLRootCertificateInput()
        }
      }).pipe(
      map(result => new DLRootCertificate(result.data['createDLRootCertificate'])));
  }

  update(id: string, rootCertificate: DLRootCertificate): Observable<DLRootCertificate> {
    return this.apollo
      .mutate({
        mutation: updateDLRootCertificateMutation,
        variables: {
          id,
          input: rootCertificate.toUpdateDLRootCertificateInput()
        }
      }).pipe(
      map(result => new DLRootCertificate(result.data['updateDLRootCertificate'])));
  }

  delete(id: string): Observable<string> {
    return this.apollo
      .mutate({
        mutation: deleteDLRootCertificateMutation,
        variables: {
          id
        }
      }).pipe(
      map(result => result.data['deleteDLRootCertificate']));
  }
}
